
import React from 'react';
import { SecurePhotoUpload } from '../SecurePhotoUpload';

interface CoachProfilePhotoSectionProps {
  currentPhotoPath?: string | null;
  userId: string;
  fallbackInitials?: string;
  onPhotoUpdated: (newPhotoPath: string | null) => void;
  disabled?: boolean;
}

export const CoachProfilePhotoSection: React.FC<CoachProfilePhotoSectionProps> = ({
  currentPhotoPath,
  userId,
  fallbackInitials,
  onPhotoUpdated,
  disabled = false
}) => {
  return (
    <SecurePhotoUpload
      currentPhotoPath={currentPhotoPath}
      userId={userId}
      fallbackInitials={fallbackInitials}
      onPhotoUpdated={onPhotoUpdated}
      disabled={disabled}
    />
  );
};
